<template>
	<div class="share">
		<div class="share-body p-3">
			<div class="control-right" v-on:click="close">
				<i title="close" class="material-icons md-18">close</i>
			</div>
			<div class="category">
				<div class="category-title">LINK</div>
				<div class="property-row">
					<div class="text-description">{{link}}</div>
					<div class="pt-2">
						<button v-if="!copied" class="btn btn-dark btn-sm" v-on:click="copyLink">
							Copy
						</button>
						<button v-else class="btn btn-green btn-sm">
							<i class="material-icons md-18" style="margin-top:-3px;">assignment_turned_in</i>
							Copied to clipboard
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name:'share',
	props: {
		link:{
			type:String
		}
	},
	computed:{
		layerId: function(){
			return this.feature.layer.id;
		}
	},
	created:function(){

	},
	data:function(){
		return {
			copied:false
		};
	},
	methods:{
		copyLink:function(){
			this.$copyText(this.link).then((e)=>{
				this.copied = true;
				setTimeout(()=>{
					this.copied = false;
				},800);
			},(e)=>{
				this.$store.dispatch('ERROR_MESSAGE_SET', {message:'Error copying to clipboard'});
				this.copied = false;
			});
		},
		close:function(){
			this.$emit('close');
		}
	}
};

</script>
<style>
.share{
	position:absolute;
	top:0;
	bottom:0;
	left:0;
	right:0;
}
.share-body{
	top:46px;
	margin:0.5rem;
	background-color:#FFF;
	position:relative;
	z-index:1;
	border-radius:4px;
	border:7px solid rgba(0,0,0,0.65);
}
.share .control-right{
	position:absolute;
	right:-8px;
	top:-8px;
	width:44px;
	height:44px;
	line-height:44px;
	text-align:center;
	cursor:pointer;
}
.share .control-right i{
	opacity:0.8;
}
.share .control-right:hover i{
	opacity:1;
}

</style>


// WEBPACK FOOTER //
// src/components/share/share.vue